import React from "react"

import RightChevron from "../images/chevron-right.svg"
import { CommunityWrapper } from "../Community/styled"
import { SubDivider } from "../Menu/styled"
import { SubItemList, SubMenuItem } from "../SubMenu/styled"
import { SubNavOptions } from "../types"

const ourProvidersItems: SubNavOptions[] = [
  {
    subMenuTitle: "Aetna",
    link: "https://cerebral.com/insurance/aetna",
  },
  {
    subMenuTitle: "Blue Cross Blue Shield",
    link: "https://cerebral.com/insurance/blue-cross-blue-shield",
  },
  {
    subMenuTitle: "Cigna",
    link: "https://cerebral.com/insurance/cigna",
  },
  {
    subMenuTitle: "Optum",
    link: "https://cerebral.com/insurance/optum",
  },
  {
    subMenuTitle: "United Healthcare",
    link: "https://cerebral.com/insurance/united-health-care",
  },
]

const OurProviders = () => {
  return (
    <CommunityWrapper>
      <h6>Our insurance partners</h6>
      <SubDivider $showOnDesktop />
      <SubItemList>
        {ourProvidersItems.map(item => (
          <a href={item.link || "/"} key={item.subMenuTitle}>
            <SubMenuItem key={item.subMenuTitle}>
              <button>{item.subMenuTitle}</button>
              <img src={RightChevron} alt="right chevron arrow" />
            </SubMenuItem>
          </a>
        ))}
      </SubItemList>
    </CommunityWrapper>
  )
}

export default OurProviders
